








import {Component, Vue} from "vue-property-decorator";
import WeeklyCalendar from "../components/WeeklyCalendar.vue";
import {verifyAuth} from "../session";

@Component({
    components: {
        WeeklyCalendar,
    },
})
export default class Index extends Vue {
    public created() {
        if (verifyAuth(false)) {
            window.location.pathname = "/calendar";
        }
    }
}
